import Vue from "vue";
import App from "./App.vue";
import router from "./router";

//vuetify
import vuetify from '@/plugins/vuetify' // path to vuetify export

//Apollo config
import apolloProvider from "@/plugins/apollo"

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  apolloProvider,
  render: (h) => h(App),
}).$mount("#app");
